import React, {Component} from 'react'
// import * as firebase from 'firebase';
import firebase from '../helper/firebase'

// import Cookies from 'universal-cookie'

import {
  Avatar,
  Button,
  Card,
  Chip,
  CircularProgress,
  Divider,
  TextField,
} from 'material-ui'

import Head from '../components/Head'
import LoggedOutCard from '../components/LoggedOutCard'
import ApplicantCardHeader from '../components/ApplicantCardHeader'
import Snack from '../components/Snack'
import UnauthorizedText from '../components/UnauthorizedText'

import Fade from 'material-ui/transitions/Fade'

import {
  GetToken
} from '../helper/functions'

import {
//   bgWhite,
//   Primary,
  Title,
} from '../helper/consts'

import '../styles/Chat.css'

const style = {
  loading:{
    alignSelf: 'center',
    width:'75px',
    height:'75px',
    marginTop:'calc(50vh - 37.5px - 64px)',
  },
  // body:{
  //   background: `linear-gradient(to top, ${bgWhite} 70%, ${Primary} 70%)`,
  // },
  // messageContainer:{
  //   display:'flex',
  //   alignItems:'center',
  //   margin:10,
  // },
  // chats:{
  //   height: 'calc(100vh - 64px - 84px - 108px - 36px)',
  //   overflow: 'scroll',
  // },
  // chatLoading:{
  //   height: 'calc((((100vh - 64px) - 84px) - 108px) - 36px)',
  //   display: 'flex',
  //   justifyContent: 'center',
  //   alignItems: 'center',
  // },
  // me:{
  //   display: 'flex',
  //   alignItems: 'center',
  //   margin: '10px',
  //   justifyContent: 'flex-start',
  // },
  // them:{
  //   display: 'flex',
  //   alignItems: 'center',
  //   margin: '10px',
  //   justifyContent: 'flex-end',
  // },
  // themChip:{
  //   flexDirection: 'row-reverse',
  // },
}

export default class Chat extends Component{
  constructor(props){
    super(props);

    this.state = {
      loggedIn:false,
      authLoading:true,
      loading:true,
      message:'',
      chatLoading:true,
      snackStatus:false,
      snackMessage:'',
      chatId:'',
      recipient:{},
    }
  }

  componentDidMount(){
    firebase.auth().onAuthStateChanged(user=>{
      if(user){
        this.setState({
          loggedIn:true,
          authLoading:false,
          loading:true,
          uid:user.uid,
          user:user.providerData[0],
          rid:this.props.match.params.rid,
          unauthorized:false,
        })
        this.getChatId(user.uid);
      }
      else{
        firebase.database().ref(`chats/${this.state.chatId}`).off();
        this.setState({
          loggedIn:false,
          authLoading:false,
          loading:true,
        })
      }
    })
  }

  componentWillUnmount(){
    if(!this.state.unauthorized && this.state.loggedIn && !this.state.loading && !this.state.chatLoading){
      firebase.database().ref(`chats/${this.state.chatId}`).off();
    }
  }

  getChatId=(uid)=>{
    // const cookies = new Cookies();
    GetToken().then(token=>{
      let myHeaders = {
        method: 'post',
        headers: {
          'Authorization': 'Bearer ' + token,
        },
      }
      const url = `https://us-central1-talent-7d36f.cloudfunctions.net/getChatId?uid=${uid}&rid=${this.props.match.params.rid}`;
      fetch(url,myHeaders)
      .then(res=>{
        console.log('res is ');
        console.log(res);
        return res.json();
      })
      .then(data=>{
        console.log('data is ');
        console.log(data);
        this.setState({loading:false,chatId:data.chatId,recipient:data.recipient})
        this.getChats(data.chatId);
      })
      .catch(err=>{
        console.log(err);
        this.setState({loading:false,unauthorized:true})
      })
    })
    // const token = cookies.get('__session')
  }

  getChats = (chatId)=>{
    const ref = firebase.database().ref();
    ref.child(`chats/${chatId}`).limitToLast(30).on('value',chat=>{
      console.log(chat.val());
      if(chat.val()!==null){
        this.setState({chatLoading:false,chats:chat.val()})
      }
      else{
        this.setState({chatLoading:false,chats:{},newChat:true})
      }
    },err=>{
      console.log(err);
      this.setState({chatLoading:false,unauthorized:true,chats:{}})
    })
  }

  sendMessageWithEnter=(e)=>{
    if(e.key==='Enter' && this.state.message.length!==0){this.send();return;}
  }

  handleFormInput=(e,formField)=>{
    this.setState({[`${formField}`]:e.target.value,messageError:false})
  }

  send=()=>{
    this.setState({sending:true})
    const {message,chatId,uid,rid,recipient,user} = this.state;
    const ref = firebase.database().ref();
    let promises = [];
    if(this.state.newChat){
      let updates = {};
      updates[`myChats/${uid}/${chatId}`] = {chatId:chatId,displayName:recipient.displayName,photoURL:recipient.photoURL||'',uid:recipient.uid};
      updates[`myChats/${rid}/${chatId}`] = {chatId:chatId,displayName:user.displayName,photoURL:user.photoURL||'',uid:uid};
      const newChatPromise = ref.update(updates)
      promises.push(newChatPromise)
      this.setState({newChat:false})
    }
    const midRef = ref.child(`chats/${chatId}`).push();
    const messagePromise = midRef.set({
      message,
      name:this.state.user.displayName,
      uid:this.state.uid,
      photo:this.state.user.photoURL,
      timestamp:Date.now(),
    })
    promises.push(messagePromise)
    Promise.all(promises)
    .then(()=>{
      this.setState({sending:false,message:''})
    })
    .catch(err=>{
      console.log(err);

      this.setState({sending:false,snackStatus:true,snackMessage:'Error saving message.'})
    })
  }

  render(){
    return(
      <React.Fragment>
        <Head title={`Chat | ${Title}`} />
        <Fade in={true}>
          <div id={this.state.loggedIn?'loggedInBody':null} className="body chatBody">
            {(this.state.loading && this.state.authLoading && !this.state.loggedIn) || (this.state.loading && !this.state.authLoading && this.state.loggedIn)? <CircularProgress style={style.loading} size={75} /> : null}
            {this.state.loading && !this.state.authLoading && !this.state.loggedIn ? <LoggedOutCard /> : null}
            {!this.state.loading && !this.state.authLoading && this.state.loggedIn ?
              <Fade in={true}>
                <Card className="dashboardCard card">
                  <ApplicantCardHeader
                    applicant={this.state.recipient || {}}
                  />
                  <Divider light />
                  <div className={this.state.chatLoading?'chatLoading':'chats'} id="chats">
                    {this.state.unauthorized?
                      <UnauthorizedText text='Unauthorized'/>
                    :
                      this.state.chatLoading?
                        <CircularProgress size={75} />
                      :
                        Object.keys(this.state.chats).map((chat,i)=>{
                          const {chats} = this.state;
                          return (
                            <Fade key={chat} in={true}>
                              <div className={this.state.uid===chats[chat].uid?'me':'them'} >
                                <Chip
                                  avatar={<Avatar src={chats[chat].photo} />}
                                  label={chats[chat].message}
                                  className={`chatChip ${this.state.uid!==chats[chat].uid?'themChip':null}`}
                                />
                              </div>
                            </Fade>
                          )
                        })
                    }
                  </div>
                  <Divider light />
                  <div className='messageContainer'>
                    <TextField
                      error={this.state.messageError}
                      fullWidth
                      autoFocus={true}
                      id="message"
                      label="Message..."
                      value={this.state.message}
                      onChange={e=>{this.handleFormInput(e,'message')}}
                      onKeyPress={this.sendMessageWithEnter}
                      margin="normal"
                    />
                    <Button disabled={this.state.message.length===0 || this.state.sending} onClick={!this.state.sending?this.send:null} raised={this.state.message.length!==0 || !this.state.sending} color={"accent"} >
                      Send
                    </Button>
                  </div>
                </Card>
              </Fade>
            :
              null
            }
            <Snack
              snackStatus={this.state.snackStatus}
              snackMessage={this.state.snackMessage}
              closeSnack={()=>{this.setState({snackStatus:false,snackMessage:''})}}
            />
          </div>
        </Fade>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Chat.js